"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendVCType = void 0;
/**
 * 发送类型
 */
var SendVCType;
exports.SendVCType = SendVCType;
(function (SendVCType) {
  SendVCType["ACCOUNT"] = "account";
  SendVCType["PHONE"] = "phone";
})(SendVCType || (exports.SendVCType = SendVCType = {}));